import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import alertsMiddleware from "./app/store/alerts/alertsMiddleware";
import reducers from "./app/store";
import authMiddleware from "./app/store/auth/authMiddleware";
import SimpleReactLightbox from "simple-react-lightbox";
import "./translation/setupMultilanguage";
import "./utils/pendingParentNavigation";
import { QueryClient, QueryClientProvider } from "react-query";
import EAFullScreenLoader from "./app/components/shared/EAFullScreenLoader";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    config: any;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk, alertsMiddleware, authMiddleware)));

const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<EAFullScreenLoader />}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <SimpleReactLightbox>
            <App />
          </SimpleReactLightbox>
        </QueryClientProvider>
      </Provider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
